<template>
    <s-t-b-y-lesson :lesson="lesson"></s-t-b-y-lesson>
</template>

<script>

import STBYLesson from './components/STBYLesson';

export default {
  name: 'stby-lessons-add',
  components: {STBYLesson},
  data() {
        return {
            lesson: {additionalInfo:{name:'', provider_id:'', provider_full_id:'', words:''}},
        }
  },
  created(){
  },
  methods: {

  },
  watch: {

  },

}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/sb-lessons/Add.vue